import { CheckOutlined, CloseOutlined, LeftOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row } from "antd";
import FormTextArea from "component/form/form_textarea";
import { useKycAdd } from "hook/base/kyc/useKyc";
import React, { useCallback, useState } from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const KycAction = () => {
  // -------------------------- VAR -----------------------------
  const { loading, handleConfirmApprove, handleConfirmDeny } = useKycAdd();
  const [form] = Form?.useForm();
  // -------------------------- STATE ---------------------------
  const [deny, setDeny] = useState(false);
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleBack = useCallback(() => {
    setDeny(false);
    form?.resetFields();
  }, [form]);
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderDeny = () => {
    if (!deny) return null;
    return (
      <Form layout="vertical" form={form} id="form-action-deny">
        <Row gutter={[10, 10]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <FormTextArea
              name="reason"
              rules={[{ required: true, message: "Vui lòng nhập lý do" }]}
              label="Lý do từ chối đơn này"
            />
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <Button
              loading={loading}
              onClick={handleBack}
              icon={<LeftOutlined />}
              block
            >
              Quay lại
            </Button>
          </Col>
          <Col xl={12} lg={12} md={12} xs={12}>
            <Button
              onClick={() => handleConfirmDeny(form)}
              type="primary"
              block
              loading={loading}
            >
              Hoàn tất
            </Button>
          </Col>
        </Row>
      </Form>
    );
  };

  const renderApprove = () => {
    if (deny) return null;
    return (
      <Row gutter={[10, 10]}>
        <Col xl={12} lg={12} md={12} xs={12}>
          <Button
            onClick={() => setDeny(true)}
            block
            loading={loading}
            danger
            icon={<CloseOutlined />}
          >
            Từ chối
          </Button>
        </Col>
        <Col xl={12} lg={12} md={12} xs={12}>
          <Button
            style={{ background: "green" }}
            loading={loading}
            block
            type="primary"
            icon={<CheckOutlined />}
            onClick={handleConfirmApprove}
          >
            Xác Nhận
          </Button>
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <>
      {renderDeny()}
      {renderApprove()}
    </>
  );
};
export default KycAction;
